module.exports = function getResource(label, vars = []) {
    const resources = {
        main: 'En cours chez Sephora',
        myReservations: 'Mes réservations',
        findASephora: 'Trouver un magasin Sephora',
        happeningAtSephoraNavigation: 'En cours chez Sephora Navigation',
        beautyServicesFaq: 'FAQ sur les services beauté',
        makeupServices: 'Services de maquillage'
    };
    return resources[label];
};
